export const TRANG_THAI_HANG_HOA = Object.freeze({
  MOI_TAO: 1,
  TRONG_MENU: 2,
  NGUNG: 3,
});

export const TRANG_THAI_PHIEU_DE_XUAT_NVL = Object.freeze({
  REJECT: -1,
  WAREHOUSE_CENTER: 1,
  WAREHOUSE_CENTER_BEYER: 2,
  IC: 3,
  ACCOUNTANT: 4,
  OPERATOR: 5,
  DONE: 6,
});

export const TRANG_THAI_NCC = Object.freeze({
  NGUNG_CUNG_CAP: 0,
  DANG_CUNG_CAP: 1,
});
